import React, { useState } from 'react';
import { ButtonContainer } from './Button.styled';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const Button = ({
    children,
    landscapeWidth,
    width,
    mobileWidth,
    mobileHeight,
    height,
    primary,
    secondary,
    secondaryWhiteBorder,
    surgery,
    scheduleSurgery,
    disabled,
    warning,
    discard,
    show,
    fontSize,
    fontSizeMobile,
    fontFamily,
    clicked,
    padding,
    margin,
    marginRight,
    borderRadius,
    cancel,
    clearNotes,
    surgeryNotesDisabled,
    listViewApply,
    color,
    backgroundColor,
    border,
    clearNotesBg,
    popUpSecondary,
    opacity,
    mobileMargin,
    boxShadow,
    disabledSaveBtn,
    WhiteSpace,
    ReceiveSets,
    mobileMarginTop,
    mobileMarginBottom,
    isJapan,
    ipadWidth,
    minWidth,
    mobileMinWidth,
    mbBorder
}) => {
    const [backgroundColorUpdate, setBackgroundColor] = useState('');
    const [borderUpdate, setBorder] = useState('');
    const [colorUpdate, setColor] = useState('');
    const [mouseDown, setMouseDown] = useState(false);

    useEffectWithErrorLogging(() => {
        if (primary) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#1010EB');
            setColor(color ? color : '#FFFFFF');
        } else if (secondary) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#FFFFFF');
            setColor(color ? color : '#1010EB');
            setBorder(border ? border : '1px solid #1010EB');
        } else if (secondaryWhiteBorder) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#FFFFFF');
            setColor(color ? color : '#1010EB');
            setBorder(border ? border : '1px solid #EBEBEB');
        } else if (surgery) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#E50B7E');
            setColor(color ? color : '#FFFFFF');
        } else if (scheduleSurgery) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#FFFFFF');
            setColor(color ? color : '#E50B7E');
            setBorder(border ? border : '1px dashed #E5047E');
        } else if (disabled) {
            if (ReceiveSets) {
                setBackgroundColor('unset');
                setColor('#9F9F9F');
                setBorder('1px solid #9F9F9F');
            } else {
                setBackgroundColor(
                    backgroundColor ? backgroundColor : '#9A9A9A'
                );
                setColor(color ? color : '#FFFFFF');
                setBorder('none');
            }
        } else if (warning) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#fcaa00');
            setColor(color ? color : '#140f4b');
            setBorder(border ? border : 'none');
        } else if (cancel) {
            setBorder('1px solid #140F4B');
            setBackgroundColor(backgroundColor ? backgroundColor : '#FFFFFF');
            setColor(color ? color : '#140f4b');
        } else if (clearNotes) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#FFFFFF');
            setColor(color ? color : '#140F4B');
            setBorder(border ? border : '1px solid #140F4B');
        } else if (surgeryNotesDisabled) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#9A9A9A');
            setColor(color ? color : '#FFFFFF');
            setBorder(border ? border : '1px solid #9A9A9A');
        } else if (discard) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#FFFFFF');
            setColor(color ? color : '#ED002A');
            setBorder(border ? border : '1px solid #ED002A');
        } else if (listViewApply) {
            setBackgroundColor(backgroundColor ? backgroundColor : '#1021EB');
            setColor(color ? color : '#FFFFFF');
        } else if (clearNotesBg) {
            setBackgroundColor('#F5F5F5');
            setColor('#140F4B');
            setBorder('1px solid #140F4B');
        } else if (popUpSecondary) {
            setBackgroundColor('#FFFFFF');
            setColor('#1010EB');
            setBorder('1px solid #1010EB');
        } else if (disabledSaveBtn) {
            setBackgroundColor('#9F9F9F');
            setColor('#FFFFFF');
            setBorder('1px solid #9F9F9F');
        }
    }, [
        primary,
        secondary,
        surgery,
        scheduleSurgery,
        secondaryWhiteBorder,
        surgeryNotesDisabled,
        clearNotes,
        cancel,
        discard,
        listViewApply,
        disabled,
        clearNotesBg,
    ]);

    const onMouseDown = () => {
        setMouseDown(true);
    };

    const onMouseUp = () => {
        setMouseDown(false);
    };

    // Touch optimization for iPad and other touch devices
    const handleTouchStart = (e) => {
        if (!disabled && clicked) {
            e.preventDefault();
            e.currentTarget.setAttribute('data-touch-handled', 'true');
            clicked(e);
        }
    };

    const handleClick = (e) => {
        const touchHandled = e.currentTarget.getAttribute('data-touch-handled');
        if (touchHandled === 'true') {
            e.currentTarget.removeAttribute('data-touch-handled');
            return;
        }
        if (!disabled && clicked) {
            clicked(e);
        }
    };

    return (
        <ButtonContainer
            isJapan={isJapan}
            show={show}
            width={width}
            landscapeWidth={landscapeWidth}
            mobileWidth={mobileWidth}
            mobileHeight={mobileHeight}
            height={height}
            backgroundColor={backgroundColorUpdate}
            border={border?border:borderUpdate}
            borderRadius={borderRadius}
            margin={margin}
            marginRight={marginRight}
            color={colorUpdate}
            padding={padding}
            fontSize={fontSize ? fontSize : undefined}
            fontSizeMobile={fontSizeMobile ? fontSizeMobile : undefined}
            fontFamily={fontFamily}
            onClick={handleClick}
            onTouchStart={handleTouchStart}
            disabled={disabled}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            mouseDown={mouseDown}
            boxShadow={boxShadow}
            opacity={opacity ? opacity : undefined}
            mobileMargin={mobileMargin}
            WhiteSpace={WhiteSpace}
            mobileMarginTop={mobileMarginTop}
            mobileMarginBottom={mobileMarginBottom}
            ipadWidth={ipadWidth}
            minWidth={minWidth}
            mobileMinWidth={mobileMinWidth}
            mbBorder={mbBorder}
        >
            {children}
        </ButtonContainer>
    );
};

export default Button;
